import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBetHistory, resetBetHistory } from "../../../redux/slices/betHistorySlice";
import { X } from "lucide-react";

const formatDate = (dateString) => {
  const date = new Date(dateString.replace(" ", "T")); // Ensure proper parsing
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }) + ", " + date.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true });
};

export const History = ({ onClose }) => {
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.betHistory);

  useEffect(() => {
    dispatch(fetchBetHistory());

    return () => {
      dispatch(resetBetHistory()); // Cleanup when unmounting
    };
  }, [dispatch]);

  const hasData = Array.isArray(data?.data) && data.data.length > 0;

  return (
    <div className="flex h-full w-full justify-center flex-col text-white xs:text-xs md:text-base lg:text-lg 2xl:text-3xl bg-[#12151D] bg-opacity-80">
      <div className="w-full h-[10%] text-white flex items-center justify-center relative text-xl sm:text-2xl md:text-4xl lg:text-5xl font-bold border-b border-gray-500">
        <span className="absolute left-1/2 transform -translate-x-1/2">History</span>
        <button
          className="absolute right-4 text-gray-50 bg-slate-700 p-1 hover:text-gray-300 text-xl rounded-full"
          onClick={onClose}
        >
          <X className="xs:w-2 xs:h-2 sm:w-3 sm:h-3 md:w-5 md:h-5 lg:w-8 lg:h-8 2xl:w-14 2xl:h-14" />
        </button>
      </div>
      <div className="w-full h-[90%] my-2 relative overflow-y-auto custom-scrollbar">
        {loading && <p>Loading...</p>}
        {error && <p className="text-red-500">{error}</p>}
        {hasData ? (
          data.data.map((bet, index) => (
            <div key={bet._id} className="w-full xs:h-[17%] md:h-[13%] xs:px-3 md:px-10 border-b border-gray-500 flex justify-between items-center">
              <div className="flex flex-row items-center">
                <div className="xs:mr-3 md:mr-5">
                  {index + 1}
                </div>
                <div className="flex flex-col items-start">
                  <div>Hand ID: {bet._id}</div>
                  <div>Lines: {bet.line}</div>
                </div>
              </div>
              <div className="flex justify-end align-text-bottom">
                Bet {bet.bet_amount}
              </div>
              <div className="flex flex-col text-right">
                {formatDate(bet.createdAt)} <br />
                Win: {bet.profit}
              </div>
            </div>
          ))
        ) : (
          !loading && <div className="flex h-full items-center justify-center xs:text-xs md:text-md lg:text-2xl 2xl:text-5xl">
            No Data Found
          </div>
        )}
      </div>

      {/* Show "Total" div only if there is data */}
      {hasData && (
        <div className="w-full h-[10%] xs:px-3 md:px-10 bg-[#F8B731] bg-opacity-30 flex justify-between items-center border-t border-[#F8B731]">
          <div className="text-[#F8B731]">Total</div>
          <div className="text-[#F8B731]">Bet: {data?.total_bet_amount || 0}</div>
          <div className="text-[#00E701]">Win: {data?.total_profit || 0}</div>
        </div>
      )}
    </div>
  );
};
